import { Button } from 'primereact/button';
import './CashDiscrepancyConfirm.scss';

interface CashDiscrepancyConfirmProps {
    /** Vuelve al formulario para revisar el monto declarado. */
    onReview: () => void;
    /** Reenvía la operación aceptando la diferencia. */
    onConfirm: () => void;
    confirming: boolean;
}

/**
 * Modal de decisión ante una discrepancia de caja (design system: notificaciones §3).
 * Reemplaza el contenido del modal del formulario, porque nunca se abre un modal encima de otro.
 * El conteo es ciego: nunca muestra el monto de la diferencia.
 */
export default function CashDiscrepancyConfirm({ onReview, onConfirm, confirming }: CashDiscrepancyConfirmProps) {
    return (
        <div className="cash-discrepancy-confirm" role="alert">
            <div className="cash-discrepancy-confirm__header">
                <i className="pi pi-exclamation-triangle" aria-hidden="true" />
                <h3 className="cash-discrepancy-confirm__title">El monto declarado no coincide con el de la caja</h3>
            </div>
            <p className="cash-discrepancy-confirm__text">
                Revisá el monto antes de seguir. Si confirmás, la diferencia queda registrada y pendiente de justificación.
            </p>
            <div className="cash-discrepancy-confirm__actions">
                <Button
                    label="Revisar el monto"
                    icon="pi pi-pencil"
                    className="buttonMain2"
                    onClick={onReview}
                    disabled={confirming}
                    autoFocus
                />
                <Button
                    label="Confirmar con diferencia"
                    icon="pi pi-check"
                    className="buttonMain"
                    onClick={onConfirm}
                    loading={confirming}
                />
            </div>
        </div>
    );
}
